var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#C6A75E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3332 34.6667C43.3198 32.72 45.3332 30.3867 45.3332 27.3333C45.3332 25.3884 44.5606 23.5232 43.1853 22.1479C41.81 20.7726 39.9448 20 37.9998 20C35.6532 20 33.9998 20.6667 31.9998 22.6667C29.9998 20.6667 28.3465 20 25.9998 20C24.0549 20 22.1897 20.7726 20.8144 22.1479C19.4391 23.5232 18.6665 25.3884 18.6665 27.3333C18.6665 30.4 20.6665 32.7333 22.6665 34.6667L31.9998 44L41.3332 34.6667Z",
    stroke: "#C6A75E",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon 8.c503babf5651d2bafec375f01237c865.svg";
export { ForwardRef as ReactComponent };